import React from "react";

import BasicNavbar from "./BasicNavbar";
import SiteFooter from "../../components/SiteFooter";

export default function RiskNoticePage() {
  return (
    <div className="dark">
      <div className="bg-background relative flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden overflow-y-auto scroll-smooth">
        <BasicNavbar />
        <main className="relative z-10 flex w-full flex-1 flex-col items-center pt-[calc(6rem+var(--intl-notice-height,0px))] pb-24">
          <section className="w-full max-w-5xl px-6 sm:px-8">
            <h1 className="text-foreground text-2xl font-semibold tracking-tight sm:text-[32px]">
              风险告知与免责声明
            </h1>
            <div className="text-default-500 mt-4 space-y-6 text-sm leading-relaxed sm:text-base">
              <section>
                <p>
                  尊敬的用户：
                </p>
                <p className="mt-2">
                  欢迎使用 3ChatClaw 数字员工平台。在您部署并激活本系统前，请务必仔细阅读以下合规承诺与风险免责条款。您的部署和使用行为，即视为对本声明全部内容的知晓与同意。
                </p>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">一、我们的合规承诺</h2>
                <p>
                  作为您的数字赋能伙伴，我们始终坚持科技向善与合规经营：
                </p>
                <ul className="mt-2 list-inside list-disc space-y-1">
                  <li>
                    <span className="font-medium text-foreground">动作合规：</span>
                    我们只做平台规则允许的自动化动作，明确划定红线，让老板用得安心。
                  </li>
                  <li>
                    <span className="font-medium text-foreground">拒绝黑产：</span>
                    坚决不做任何形式的协议破解、刷量、诱导及虚假数据制造行为。
                  </li>
                  <li>
                    <span className="font-medium text-foreground">边界透明：</span>
                    平台红线清单与操作边界公开透明，不作过度承诺。
                  </li>
                  <li>
                    <span className="font-medium text-foreground">内容安全：</span>
                    提供合规话术模板指导，极力协助商家规避因内容违规带来的账号风险。
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">
                  二、第三方平台规则变动的免责声明
                </h2>
                <p>
                  尽管 3ChatClaw 预置的 Skill 均基于资深的行业运营经验打磨，并已在技术和行为逻辑上最大程度模拟真人交互以规避已知风控，但您必须了解并同意：
                </p>
                <ol className="mt-2 list-inside list-decimal space-y-1">
                  <li>
                    <span className="font-medium text-foreground">不可控的算法变更：</span>
                    第三方社交与电商平台（包括但不限于微信、小红书、抖音、淘宝等）的用户协议、反作弊算法和风控规则处于高频的动态调整之中。我们无法预判或控制第三方平台的所有规则变化。
                  </li>
                  <li>
                    <span className="font-medium text-foreground">账号损失免责：</span>
                    若因第三方平台规则单方面变更、风控算法升级、或由于您自身设定的业务话术 / 执行频率不当，导致您的第三方平台账号遭到限流、降权、功能限制甚至永久封禁，3Chat 及其运营主体对此不承担任何连带责任及经济赔偿。
                  </li>
                </ol>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">
                  三、系统最高权限与本地数据安全免责
                </h2>
                <p>
                  3ChatClaw 底层依托 OpenClaw 自动化框架构建。为了实现跨端、跨应用的深度工作流接管，本系统在运行期间理论上具备操作您本地计算机甚至调取最高控制权（如 Root 权限、底层文件读写权限、系统无障碍权限等）的能力。
                </p>
                <p className="mt-2">
                  基于此技术特性，我们向您发出最强烈的安全建议并声明：
                </p>
                <ol className="mt-2 list-inside list-decimal space-y-1">
                  <li>
                    <span className="font-medium text-foreground">强烈建议使用“专属干净设备”：</span>
                    为了您的绝对数据安全，请务必将 3ChatClaw 部署在一台独立、干净、且未存放任何重要个人隐私（如私人聊天记录）、核心商业机密及金融密钥的专属设备上（例如作为“数字员工”专属工位的 Mac mini 或闲置备用机）。
                  </li>
                  <li>
                    <span className="font-medium text-foreground">数据灭失与泄漏免责：</span>
                    若您执意将本系统与您的主力办公 / 私人设备混用，在此期间因系统运行、指令误读、或不可抗力的技术故障导致的文件被误删、密码丢失、隐私数据泄露或系统崩溃，相关风险及损失由您自行承担，3Chat 不承担任何修复、赔偿及法律责任。
                  </li>
                </ol>
              </section>

              <section>
                <h2 className="text-foreground mb-2 text-base font-semibold sm:text-lg">
                  四、AI 自动化代理的通用风险须知
                </h2>
                <p>
                  参考行业自动化代理（AI Agent）的通用规范，您在使用过程中还需注意以下风险：
                </p>
                <ol className="mt-2 list-inside list-decimal space-y-1">
                  <li>
                    <span className="font-medium text-foreground">指令理解的不确定性：</span>
                    由大语言模型（LLM）驱动的 Agent 在执行复杂非结构化任务时，可能存在极低概率的“幻觉”或对自然语言指令的误解。请在下发关键任务（如批量发送信息）前，务必做好小范围测试，系统按您的指令执行所产生的业务后果由您自行负责。
                  </li>
                  <li>
                    <span className="font-medium text-foreground">授权凭证的安全保管：</span>
                    请妥善保管您的 3Chat 登录凭证、绑定的设备码以及相关 API 密钥。因您个人保管不善导致的控制权被盗用或恶意下发任务，后果概由用户承担。
                  </li>
                </ol>
              </section>
            </div>
          </section>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}

